import { ActivateDeactivatePageDto, FwVersionContentAndMetadata } from '../dtos/version.dto';
import axiosService from './axios-service';

class ActivationService {
    public updatePageActivation = async (customerId: number, sid: number, externalId: string, activateDeactivatePageDto: ActivateDeactivatePageDto)
        : Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/activate-deactivate-page`, {
            externalId,
            ...activateDeactivatePageDto,
        });
        return result?.data;
    };
}

const activationService = new ActivationService();
export default activationService;